// extracted by mini-css-extract-plugin
module.exports = {"TagOptions":"TagOptions_TagOptions__2u87h","Header":"TagOptions_Header__mJ9Pf","Title":"TagOptions_Title__C--nW"};